import { apiClient } from '@/core/api/client';
import { 
  Automation, 
  AutomationFormData, 
  AutomationLog, 
  AutomationStats 
} from '../types/automatisation.types';

export const automatisationApi = {
  // Get all automations
  getAllAutomations: async (): Promise<Automation[]> => {
    const response = await apiClient.get<{ success: boolean; data: Automation[] }>('/api/admin/automatisation');
    return response.data;
  },

  // Get single automation
  getAutomation: async (id: string): Promise<Automation> => {
    const response = await apiClient.get<{ success: boolean; data: Automation }>(`/api/admin/automatisation/${id}`);
    return response.data;
  },

  // Create new automation
  createAutomation: async (data: AutomationFormData): Promise<Automation> => {
    const response = await apiClient.post<{ success: boolean; data: Automation }>('/api/admin/automatisation', data);
    return response.data;
  },

  // Update automation
  updateAutomation: async (id: string, data: Partial<AutomationFormData>): Promise<Automation> => {
    const response = await apiClient.put<{ success: boolean; data: Automation }>(`/api/admin/automatisation/${id}`, data);
    return response.data;
  },

  // Delete automation
  deleteAutomation: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/admin/automatisation/${id}`);
  },

  // Toggle automation status
  toggleAutomation: async (id: string): Promise<Automation> => {
    const response = await apiClient.put<{ success: boolean; data: Automation }>(`/api/admin/automatisation/${id}/toggle`);
    return response.data;
  },

  // Get automation logs
  getAutomationLogs: async (
    id: string,
    limit: number = 50,
    offset: number = 0
  ): Promise<{ logs: AutomationLog[]; total: number; limit: number; offset: number }> => {
    const response = await apiClient.get<{ success: boolean; data: { logs: AutomationLog[]; total: number; limit: number; offset: number } }>(`/api/admin/automatisation/${id}/logs`, {
      params: { limit, offset }
    });
    return response.data;
  },

  // Get automation statistics
  getAutomationStats: async (): Promise<AutomationStats> => {
    const response = await apiClient.get<{ success: boolean; data: AutomationStats }>('/api/admin/automatisation/stats');
    return response.data;
  },

  // Manually execute automation (admin only)
  executeAutomation: async (id: string): Promise<{
    task_id: string;
    status: string;
    execution_duration_ms: number;
    next_execution_at: string;
  }> => {
    const response = await apiClient.post<{
      success: boolean;
      data: {
        task_id: string;
        status: string;
        execution_duration_ms: number;
        next_execution_at: string;
      };
    }>(`/api/admin/automatisation/${id}/execute`);
    return response.data;
  }
};